import { smoothScrollTo } from "../../../../utils/smoothScroll";

const Second = () => {
  return (
    <section className="relative py-24 lg:py-32 bg-white" id="divisions">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid opacity-30" />

      <div className="relative z-10 mx-auto max-w-7xl px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-[#1f2fd6] uppercase tracking-wider">
            Nossas Divisões
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#212223]">
            Duas formas de <span className="gradient-text-blue">transformar</span> seu negócio
          </h2>
          <p className="mt-4 text-lg text-[#5a5a5a] max-w-2xl mx-auto">
            Seja você uma grande corporação ou uma empresa em crescimento,
            temos a solução certa para suas necessidades.
          </p>
        </div>

        {/* Division Cards */}
        <div className="grid md:grid-cols-2 gap-8">

          {/* Labs Card */}
          <div
            id="labs"
            className="group relative p-8 lg:p-10 rounded-2xl bg-[#f6f6f6] border border-[#1f2fd6]/20 hover:border-[#1f2fd6]/40 transition-all duration-500 shadow-lg shadow-[#1f2fd6]/5"
          >
            {/* Glow Effect */}
            <div className="absolute inset-0 rounded-2xl bg-[#c1d5ed]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

            <div className="relative z-10">
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#1f2fd6]/10 flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>

              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1f2fd6]/10 text-[#1f2fd6] text-xs font-medium mb-4">
                <span>Enterprise</span>
              </div>

              {/* Title */}
              <h3 className="text-2xl lg:text-3xl font-bold text-[#212223] mb-4">
                Arkspace <span className="text-[#1f2fd6]">Labs</span>
              </h3>

              {/* Description */}
              <p className="text-[#5a5a5a] mb-6 leading-relaxed">
                Da estratégia à execução, seu parceiro para transformar
                desafios complexos em vantagem competitiva com IA.
              </p>

              {/* Features List */}
              <ul className="space-y-3 mb-8">
                {[
                  'Diagnóstico estratégico personalizado',
                  'Co-criação de soluções sob medida',
                  'Integração com sistemas legados',
                  'Acompanhamento e gestão contínua',
                ].map((feature, index) => (
                  <li key={index} className="flex items-center gap-3 text-[#5a5a5a]">
                    <svg className="w-5 h-5 text-[#1f2fd6] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button
                onClick={() => smoothScrollTo('contact')}
                className="w-full py-4 bg-[#1f2fd6] text-white font-medium rounded-xl hover:bg-[#0c1aa6] transition-all hover:shadow-lg hover:shadow-[#1f2fd6]/25"
              >
                Agendar diagnóstico
              </button>

              {/* Ideal For */}
              <p className="mt-4 text-xs text-[#5a5a5a] text-center">
                Ideal para grandes corporações e projetos complexos
              </p>
            </div>
          </div>

          {/* Go Card */}
          <div
            id="go"
            className="group relative p-8 lg:p-10 rounded-2xl bg-[#f6f6f6] border border-[#1f2fd6]/20 hover:border-[#1f2fd6]/40 transition-all duration-500 shadow-lg shadow-[#1f2fd6]/5"
          >
            {/* Glow Effect */}
            <div className="absolute inset-0 rounded-2xl bg-[#c1d5ed]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

            <div className="relative z-10">
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#1f2fd6]/10 flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>

              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1f2fd6]/10 text-[#1f2fd6] text-xs font-medium mb-4">
                <span>PMEs</span>
              </div>

              {/* Title */}
              <h3 className="text-2xl lg:text-3xl font-bold text-[#212223] mb-4">
                Arkspace <span className="text-[#1f2fd6]">Go</span>
              </h3>

              {/* Description */}
              <p className="text-[#5a5a5a] mb-6 leading-relaxed">
                Automatize suas tarefas com nossas soluções prontas,
                otimize seu tempo e foque no crescimento da sua empresa.
              </p>

              {/* Features List */}
              <ul className="space-y-3 mb-8">
                {[
                  'Implementação rápida e simplificada',
                  'Chatbots inteligentes para atendimento',
                  'Automação de processos repetitivos',
                  'Preços acessíveis e escaláveis',
                ].map((feature, index) => (
                  <li key={index} className="flex items-center gap-3 text-[#5a5a5a]">
                    <svg className="w-5 h-5 text-[#1f2fd6] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button
                onClick={() => smoothScrollTo('contact')}
                className="w-full py-4 border border-[#1f2fd6] text-[#1f2fd6] font-medium rounded-xl hover:bg-[#1f2fd6] hover:text-white transition-all"
              >
                Conhecer soluções
              </button>

              {/* Ideal For */}
              <p className="mt-4 text-xs text-[#5a5a5a] text-center">
                Ideal para PMEs e empreendedores em crescimento
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="mt-16 text-center">
          <p className="text-[#5a5a5a]">
            Não sabe qual é a melhor opção para você?{' '}
            <button
              onClick={() => smoothScrollTo('contact')}
              className="text-[#1f2fd6] hover:underline font-medium"
            >
              Fale com nossa equipe
            </button>
          </p>
        </div>
      </div>
    </section>
  )
}

export default Second;
